import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';

import { useFolderAction } from '@_features/folder';
import { FOLDER_CONSTANTS } from '@_entities/content';

import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { InputField } from '@_shared/ui/InputField';
import { SingleInputFormPopup } from '@_shared/ui/Popup';
import { Typography } from '@_shared/ui/Typography';

import { clearFolderListCache, folderToast, sanitizeFolderName } from '../../libs';
import * as S from './FolderCreatePopup.style';

const ERROR_CODE = {
	DUPLICATED_FOLDER_NAME: 400,
	FOLDER_MAX_COUNT_OVER: 422,
};
export function FolderCreatePopup() {
	const queryClient = useQueryClient();
	const { popLayer } = useUILayerStore();
	const { createFolder } = useFolderAction();
	const [folderNameInput, setFolderNameInput] = useState<string>('');
	const [isCreateError, setIsCreateError] = useState<boolean>(false);

	function handleOnInput(e: React.ChangeEvent<HTMLInputElement>) {
		const sanitizedFolderName = sanitizeFolderName(e.target.value);

		e.target.value = sanitizedFolderName;
		setFolderNameInput(sanitizedFolderName);
		setIsCreateError(false);
	}

	function handleSubmit() {
		const trimmedFolderNameInput = folderNameInput.trim();

		// updateFolderName({ folderId, name: trimmedFolderNameInput });
		createFolder(trimmedFolderNameInput)
			.then(() => {
				clearFolderListCache(queryClient);
				window.location.reload();
			})
			.catch((error) => {
				if (error.status === ERROR_CODE.DUPLICATED_FOLDER_NAME) {
					setIsCreateError(true);
				} else if (error.status === ERROR_CODE.FOLDER_MAX_COUNT_OVER) {
					folderToast().maxFolderCount();
				}
			});
	}

	function isSubmitDisabled() {
		return folderNameInput.length === 0;
	}

	return (
		<SingleInputFormPopup.Container closePopup={popLayer}>
			<SingleInputFormPopup.TextContainer>
				<SingleInputFormPopup.Title>폴더 추가</SingleInputFormPopup.Title>
				<SingleInputFormPopup.Button
					disabled={isSubmitDisabled() || isCreateError}
					onClick={() => {
						handleSubmit();
					}}
				>
					<Typography
						type="title-small"
						color={
							isSubmitDisabled() || isCreateError ? 'font-tertiary' : 'orange-primary'
						}
					>
						저장
					</Typography>
				</SingleInputFormPopup.Button>
			</SingleInputFormPopup.TextContainer>

			<InputField
				value={folderNameInput}
				onChange={handleOnInput}
				type="text"
				minLength={FOLDER_CONSTANTS.FOLDER_NAME_MIN_LENGTH}
				maxLength={FOLDER_CONSTANTS.FOLDER_NAME_MAX_LENGTH}
				onInput={handleOnInput}
				placeholder="폴더 이름을 입력해주세요."
				borderColor={isCreateError ? 'orange-primary' : 'warmgray-200'}
			>
				<S.Counter type="label-medium" color="warmgray-400">
					{folderNameInput.length}/{FOLDER_CONSTANTS.FOLDER_NAME_MAX_LENGTH}
				</S.Counter>
			</InputField>

			{isCreateError && (
				<SingleInputFormPopup.ErrorMessage>
					이미 사용 중인 폴더명입니다.
				</SingleInputFormPopup.ErrorMessage>
			)}
		</SingleInputFormPopup.Container>
	);
}
